import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/layout';
import Head from 'components/head';
import { Heading, Text, Flex, Accordion, AccordionItem, AccordionButton, Box, AccordionIcon, AccordionPanel, List, ListIcon, ListItem } from '@chakra-ui/react';
import { accentText } from '../../constants/theme';
import HeroSection from '../../components/heroSection';
import { graphql, useStaticQuery } from 'gatsby';
import Proyectos from '../../components/proyectos';
import ProyectoCard from '../../components/proyectoCard';
// import { VideoSchema } from '../../helpers/schemaGenerator';
import ContactBanner from '../../components/contactBanner';
import ReactCompareImage from 'react-compare-image';
import { ChevronRightIcon, ExternalLinkIcon, InfoOutlineIcon } from '@chakra-ui/icons';
import { StaticImage } from 'gatsby-plugin-image';

import conEscenario from '../../../content/images/servicios/escenarios/CuervoVP-conEscenarioVirtualc.jpg'
import conEscenario2 from '../../../content/images/servicios/escenarios/CuervoVP-conEscenarioVirtual2c.jpg'
import sinEscenario from '../../../content/images/servicios/escenarios/CuervoVP-greenScreenc.jpg'
import sinEscenario2 from '../../../content/images/servicios/escenarios/CuervoVP-greenScreen2c.jpg'

const ListLink = ({to, label}) => (
  <>
    <ListItem lineHeight="1.9">
      <ListIcon as={ChevronRightIcon} color="azulin.500" />
      <a href={to} style={{ color: '#333', textDecoration: 'underline'}}>{label}</a>
      <ExternalLinkIcon ml="2" fontSize="12px" color="azulin.500" />
    </ListItem>
  </>
);
ListLink.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

const FaqItem = ({q, a}) => (
  <>
    <h3>
      <AccordionButton 
        _expanded={{ bg: '#1f9ee4cc', color: 'white' }}
        fontWeight="bold" fontSize="calc(.95em + .2vw) "
        color={'#888'} 
        lineHeight="1.5" 
        p={4}
        borderTop="1px solid #ccc"
        height="80px">
        <InfoOutlineIcon mr={3} color="#78caf7" />
        <Box flex="1" textAlign="left" >
          {q}
        </Box>
        <AccordionIcon color="azulin.500"/>
      </AccordionButton>
    </h3>
    <AccordionPanel p={4} minHeight="160px" lineHeight="1.5" fontSize="1.1em">
      {a}
    </AccordionPanel>
  </>
);
FaqItem.propTypes = {
  q: PropTypes.string.isRequired,
  a: PropTypes.string.isRequired,
};

const SetVirtual = ({ lang = 'es' }) => {
  const l = (...texts) => lang === 'en' ? texts[1] : texts[0]
  const data = useStaticQuery(
    graphql`query SetVirtualQuery {
      headerImg: file(
        relativePath: {eq: "images/servicios/escenarios/dolly-motion-tracking-grabacion-virtual2.jpeg"}
      ) {
        childImageSharp {
          gatsbyImageData(quality: 80, layout: FULL_WIDTH, formats: [AUTO, WEBP, AVIF])
          resize(width: 1200, height: 630, quality: 80, cropFocus: ENTROPY, fit: INSIDE) {
            src
          }
        }
      }
      headerImgMovil: file(
        relativePath: {eq: "images/servicios/escenarios/headerMovil_comp.jpeg"}
      ) {
        childImageSharp {
          gatsbyImageData(width: 600, quality: 80, layout: FULL_WIDTH, formats: [AUTO, WEBP, AVIF])
        }
      }
      proyectoFf: mdx(
        fields: {slug: {eq: "/free-fire-aniversario-concierto-virtual-3d-streaming"}}
      ) {
        ...ProyectoCardData
      }
      proyectoPlanBermuda: mdx(
        fields: {slug: {eq: "//escape-room-realidad-virtual-aumentada"}}
      ) {
        ...ProyectoCardData
      }
      proyectoTvazteca: mdx(
        fields: {slug: {eq: "/3d-mapping-balon-aspid-limpiemos-nuestro-mexico"}}
      ) {
        ...ProyectoCardData
      }
    }
  `)

  const pageTitle = l('Produccion Virtual y Sets Virtuales para Producción de Cine, TV, Publicidad y Broadcast en vivo', 
    'Virtual Production and Virtual Sets for digital Film Production, TV, Advertising and Live Broadcasting')
  const pageImage = 'https://visualma.com' + data.headerImg.childImageSharp.resize.src;
  const pageDescription =
    l('Escenarios Virtuales, Set Virtual, motion capture, escenarios fotorealistas para producción de Cine, TV, Publicidad, live Broadcast Y VFX en tiempo real en México', 
      'Virtual Sets, virtual production, motion capture, photorealistic environments for film production, TV, advertising, live broadcast and realtime VFX')
  // const pageUrl = 'https://visualma.com/escenario-virtual-set-virtual-cine-tv;
  const MedImgProps = {
    layout: 'constrained',
    width: 800,
    height: 450,
    formats: ['auto', 'webp', 'avif'],
  }

  return (
    <Layout lang={lang}>
      <Head lang={lang}
        pageTitle={pageTitle}
        imageUrl={pageImage}
        pageDescription={pageDescription}
      />
      {/* <VideoSchema
        videoUrl="https://www.youtube.com/embed/goiihJ5cRLI"
        contentUrl={pageUrl}
        imageUrl={pageImage}
        title={pageTitle}
        description={'Ejemplos de Realidad virtual en México creados por la agencia Visualma'}
        date="2020-07-07T00:21:41Z"
        duration="PT52S"
      /> */}

      <div>
        <HeroSection
          header={true}
          headerImg={data.headerImg.childImageSharp.gatsbyImageData}
          headerImgMovil={data.headerImgMovil.childImageSharp.gatsbyImageData}
          title={l('Producción virtual y Sets Virtuales', 'Virtual Production & Virtual Set')}
          parrafoGrande={
            l(<><b>Producción virtual y Sets Virtuales</b><small> para Producción de Cine, TV, Publicidad y Broadcast en vivo</small></>,
              <><b>Virtual production & Virtual Sets</b><small> for filmmaking, tv, marketing and live broadcast</small></>)
          }
          contentHeight="auto"
          parrafoPequeno={''}
        />

        <Flex
          bg="transparent"
          justify="flex-start"
          direction="column"
          m="2em auto 5em"
          maxWidth="50em"
        >
          <Heading as="h2" className="subHeader" mb="0.5em" >
            <small>
              {l('Convierte tu set en cualquier locación imaginable con escenarios virtuales fotorealistas y efectos especiales en tiempo real',
                'Transform your production set into any location you want, with pothorealistic virtual sets and realtime VFX and compositing.')}
            </small>
          </Heading>
        </Flex>

        <Flex
          bg="transparent"
          justify="flex-start"
          direction="column"
          m="4em auto 0"
          maxWidth="70em"
        >

          <ReactCompareImage 
            leftImage={sinEscenario} leftImageAlt={l('Imagen de video grabado en set green screen','Photo of a video recording using a green screen')}
            rightImage={conEscenario} rightImageAlt={l('Frame de video de green screen integrado con escenario virtual','Frame from a video captured on a green screen with an integrated virtual background')}
            handleSize='40'
            hover={true}
          />


          <Heading as="h2" className="subHeader" textAlign="center" mt="1.9em" mb="1.4em">{l('¿Qué es la producción virtual y los sets virtuales?', 'What is Virtual Production and Virtual Sets?')} </Heading>
          <Text fontSize="xl" className="parrafoChico">
            
            {l('Las producciónes virtuales de video utilizan técnicas especializadas de grabación con pantalla verde y captura de movimiento (motion tracking) en cámaras y actores para lograr en set el mismo efecto que se tiene en una locación de cine, reduciendo costos. A diferencia de la pantalla verde tradicional, la imagen final contiene todos los efectos virtuales desde que se captura en cámara.', 
            'Virtual Production is the use of innovative techniques where motion tracked cameras and actors are recorded in front of a green screen or LED screen volume, and the image is altered in realtime to compose virtual environments, characters and VFX. Crucially, the final image contaning the digital composite is obtained on set instantly.')}
            <br /><br />

            {l('La previsualización a tiempo real de  escenarios virtuales permite que el director tenga un control revolucionario sobre la escena virtual, ya que puede combinar los ambientes virtuales y la toma en el set real en vivo, personalizando los parámetros de cada cámara, escenario e iluminación del ambiente.',
            'The ability to easily transform into any location and see immediate results opens up possibilities while reducing costs. Real time visualization of the virtual set gives directors and photographers full control over the scene. Parameters such as environment lighting, virtual objects placement and virtual camera characteristics can be changed instantly.')}
            <br /><br />
            {l('Los escenarios y sets virtuales son utilizados en broadcast y cine digital, grabación con ambientes fotorrealistas en tiempo real y todo tipo de soluciones para producción de cine, publicidad, noticieros de TV y programas de  Youtube, real-time VFX, visualización de datos y estadísticas a tiempo real, conciertos y transmisiones en vivo.',
            'Virtual sets and virtual environments are becoming an integral part of video production in many industries, including broadcast, digital film, streaming services, advertising, news, YouTube and influencer content, real-time VFX, real-time data and statistics visualization, music videos, concerts and festivals, and live streaming.')}
            <br /><br /><br />
          </Text>

           <ReactCompareImage
            leftImage={sinEscenario2} leftImageAlt={l('Imagen de video grabado en set green screen', 'Image of a video that was recorded in front of a green screen.')}
            rightImage={conEscenario2} rightImageAlt={l('Frame de video de green screen integrado con escenario virtual', 'Frame of a green-screen video with a virtual set composited in the background.')}
            handleSize='40'
            hover={true}
          />
        </Flex>


        <Flex
          bg="transparent"
          justify="flex-start"
          direction="column"
          m="3em auto"
        >
          <Heading as="h2" className="subHeader" mb="2em">
            {l('Casos de uso en diferentes industrias', 'Case studies and industry adoption')}
            <br />
            <small>{l('¿Para que sirve la producción virtual de video y los escenarios virtuales?','How is Virtual Production providing solutions and transforming industries')}</small>
          </Heading>
          <Flex
            flexDirection={['column', 'row']}
            maxWidth={['95%', '95%', '95%', '80em']}
            margin="0 auto"
            lineHeight="1.5"
            fontSize="lg"
            style={{
              paddingLeft: '1em',
              textIndent: '-1.5em',
              width: '886px'
            }}
          >
            <List
              spacing={3}
              m={['0 auto 1em', '0 auto 3em']}
              marginRight={['auto', '4em']}
              maxWidth={['95%', '460px']}
              width="100%"
            >
              <ListLink to="#cineProd" label={l('Producciones de Cine','Film Production')} />
              <ListLink to="#tvProd" label={l('Publicidad y Televisión','TV and Advertising')} />
              <ListLink to="#liveProd" label={l('Eventos en vivo y Conciertos Virtuales','Live Events and Virtual Concerts')} />
              <ListLink to="#corpProd" label={l('Convenciones corporativas Virtuales','Corporate Events and conventions')} />
              <ListLink to="#broadcastProd" label={l('Broadcast de TV y Estudios de Producción','Broadcast and TV Studios')} />
              <ListLink to="#esportsProd" label={l('E-Sports y Efectos Especiales real-time','E-Sports and streaming of real-time VFX')} />
              <ListLink to="#dataProd" label={l('Análisis de datos y Gráficas Electorales','Data analysis and electoral graphs')} />
            </List>
            <List
              spacing={3}
              m="0 auto 3em"
              maxWidth={['95%', '460px']}
              width="100%"
            >
              <ListLink to="#newsProd" label={l('NewsRoom\'s, Programas de TV y YouTube','NewsRoom\'s, TV Programs and YouTube')} />
              <ListLink to="#eduProd" label={l('Ecenarios virtuales Educativos','Virtual Sets in Education')} />
              <ListLink to="#publicidadProd" label={l('Campañas de publicidad interactivas','Interactive Advertising Campaings')} />
              <ListLink to="#mocapProd" label={l('Motion Capture (MoCap) en México','Motion Capture (MoCap)')} />
              <ListLink to="#artProd" label={l('Teatro y Arte escenico','Theater and Scenic Arts')} />
              <ListLink to="#inmersiveProd" label={l('Experiencias inmersivas de Realidad Virtual','Immersive VR Experiences')} />
              <ListLink to="#parkProd" label={l('Parques de Diversiones y Museos','Museums and Amusement Parks')} />
              <ListLink to="#faq" label={l('Preguntas frecuentes sobre producciones virtuales','FAQs on Virtual Production')} />
            </List>
          </Flex>
        </Flex>




        <Flex className="flexList flexListLeft">
          
          <Flex flexWrap="wrap">
            <Flex id="cineProd" className="columna img">
              <Heading as="h3">{l('Escenarios Virtuales para producciones de Cine','Virtual Sets for Film Production')}</Heading>
              <Text fontSize="xl" className="parrafoChico">
                {l('La producción virtual está revolucionando la industria del Cine y TV. Fenómenos culturales como The Mandalorian utilizan la técnica para generar locaciones fantásticas y efectos especiales en cámara reduciendo presupuesto.',
                'Virtual Production is transforming the way Film & TV is made. Universally acclaimed programs such as The Mandalorian use the technique to transport their story to fantastic locations using in-camera VFX and reducing costs.')}
              </Text>
            </Flex>
            <Flex className="columna img">
              <StaticImage
                {...MedImgProps}
                src="../../../content/images/servicios/escenarios/grabacion-green-screen-set-virtual.jpeg"
                className="shadow-md-white"
                alt={l('Set de grabación en green screen con dos actores y claqueta y una pantalla con Escenarios virtuales para produccion de cine en México','Green screen production set with two actors standing, a clapperboard and a screen showing multiple virtual environments for film production in Mexico.')}
                />
            </Flex>
          </Flex>
          
          <Flex flexWrap="wrap-reverse">
            <Flex className="columna img">
              <StaticImage
                {...MedImgProps}
                src="../../../content/images/servicios/escenarios/dolly-motion-tracking-grabacion-virtual2.jpeg"
                className="shadow-md-white"
                loading="lazy"
                alt={l('Set de grabacion para producción virtual y escenarios virtuales','Recording set used for virtual production and virtual sets')}
              />
            </Flex>
            <Flex id="tvProd" className="columna img">
              <Heading as="h3">{l('Sets Virtuales para Publicidad y TV','Virtual Sets for TV and Advertising')}</Heading>
              <Text fontSize="xl" className="parrafoChico">
                {l('La Produción Virtual permite que los comerciales utilicen cualquier locación imaginable, ajustada exactamente al producto y la marca. Con la producción virtual, puedes cambiar el ambiente de inmediato con un solo click.',
                'Virtual Production enables commercials to use any location imaginable, customized to fit product and brand. With virtual production, the recording environment can be changed with a single click.')}
              </Text>
            </Flex>
          </Flex>

          <Flex id="liveProd" className="columna img">
            <Heading as="h3">{l('Eventos en vivo y Conciertos Virtuales', 'Live Events and Virtual Concerts')}</Heading>
            <Text fontSize="xl" className="parrafoChico">
              <b>{l('Conciertos y festivales virtuales transmitidos en tiempo real', 'Concerts and music festivals in virtual spaces, live broadcasted to wide audiences.')}</b>
            </Text>
            <List
              spacing={3}
              m={['0.5em auto 1em', '0.5em auto 2em']}
              marginLeft="0em"
              paddingLeft="0"
              maxWidth="100%"
              width="100%"
            >
              <ListItem>
                <ListIcon as={ChevronRightIcon} color="azulin.500" />
                  {l('Infraestructura para festivales masivos no presenciales','We provide the infrastructure for remote mass events')}
                </ListItem>
              <ListItem>
                <ListIcon as={ChevronRightIcon} color="azulin.500" />
                  {l('Escenografía virtual para conciertos y videos musicales','Virtual scenery and sets for concerts and music videos')}
                </ListItem>
              <ListItem>
                <ListIcon as={ChevronRightIcon} color="azulin.500" />
                  {l('Animaciones dinámicas reactivas al audio','Audio-reactive animations and dynamics')}
                </ListItem>
              <ListItem>
                <ListIcon as={ChevronRightIcon} color="azulin.500" />
                  {l('Captura de imagen y sonido con técnicas de virtual production','Capture of video and audio using Virtual Production techniques')}
                </ListItem>
              <ListItem>
                <ListIcon as={ChevronRightIcon} color="azulin.500" />
                  {l('Infraestructura web escalable a decenas de miles de usuarios','Cloud infrastructure that dinamically scales from dozens to hundreds of thousands of users')}
                </ListItem>
              <ListItem>
                <ListIcon as={ChevronRightIcon} color="azulin.500" />
                  {l('Operación de los equipos durante el evento.','Equipment operation and supervision during the event')}
                </ListItem>
            </List>
            <Text fontSize="xl" className="parrafoChico">
              {l('Hacemos posibles eventos masivos que los usuarios pueden vivir desde casa.','We make it possible for users to live massive live events from the comfort of their homes.')}
            </Text>
          </Flex>
          <Flex className="columna full">
            <ProyectoCard
              data={data.proyectoFf}
            // darkMode
            // autoPlay
            />
          </Flex>
          
          <Flex flexWrap="wrap-reverse">
            <Flex className="columna img">
              <StaticImage
                {...MedImgProps}
                src="../../../content/images/servicios/escenarios/ProduccionVirtual-greenScreen-mexico_comp.jpeg"
                className="shadow-md-white"
                loading="lazy"
                alt={l('Grabación de eventos corporativos en escenarios virtuales para convenciones virtuales','Recording corporate events in virtual sets for virtual conventions')}
              />
            </Flex>
            <Flex id="corpProd" className="columna img">
              <Heading as="h3">{l('Eventos corporativos y Convenciones Virtuales','Corporate Events and Virtual Conventions')}</Heading>
              <Text fontSize="xl" className="parrafoChico">
                {l(<>Crea <b>experiencias únicas y memorables</b> tanto en el mundo real como en el mundo virtual.</>,
                <>We can help you offer <b>unique, memorable experiences</b> in the virtual world.</>)}
              </Text>
              <List
                spacing={3}
                m={['0.5em auto 1em', '0.5em auto 2em']}
                marginLeft="0em"
                paddingLeft="0"
                maxWidth="100%"
                width="100%"
              >
                <ListItem>
                  <ListIcon as={ChevronRightIcon} color="azulin.500" />
                    {l('Presentaciones corporativas virtuales','Corporate virtual presentations')}
                </ListItem>
                <ListItem>
                  <ListIcon as={ChevronRightIcon} color="azulin.500" />
                    {l('Reportes y gráficas en realidad aumentada','Reports and graphs in augmented reality')}
                </ListItem>
                <ListItem>
                  <ListIcon as={ChevronRightIcon} color="azulin.500" />
                    {l('Convenciones virtuales','Virtual Conventions')}
                </ListItem>
                <ListItem>
                  <ListIcon as={ChevronRightIcon} color="azulin.500" />
                    {l('Platicas inmersivas','Immersive conferences and seminars')}
                </ListItem>
                <ListItem>
                  <ListIcon as={ChevronRightIcon} color="azulin.500" />
                    {l('Exposiciones y Trade shows digitales','Virtual Trade Shows and Expos')}
                </ListItem>
              </List>
              <Text fontSize="xl" className="parrafoChico">
                {l('Soluciones efectivas para mantener la continuidad de la comunicación y el crecimiento de la empresa a través de tecnologías no presenciales.','Solutions for effective continuous communications leveraging remote presence technologies.')}
              </Text>
            </Flex>
          </Flex>
          
          <br /><br /><br />
          
          <Flex flexWrap="wrap">
            <Flex id="broadcastProd" className="columna img">
              <Heading as="h3">{l('Broadcast de TV y Estudios de Producción','TV Broadast Studios')}</Heading>
              <Text fontSize="xl" className="parrafoChico">
                {l('Instalación en sitio de soluciones especializadas para producción virtual en sets de TV y broadcast. Prepara tu foro para el futuro con sistemas de tracking, cámaras robóticas, captura y control de señales, renderizado de escenarios y monitoreo virtual.',
                'On-site installation of integrated Virtual Production solutions for existing broadcast sets. We can help you modernize and future-proof your forum with camera tracking systems, robotics, video capture, real-time rendering of virtual sets, virtual monitoring and live compositing.')}
              </Text>
            </Flex>
            <Flex className="columna img">
              <StaticImage
                {...MedImgProps} 
                src="../../../content/images/servicios/escenarios/the-mandalorian-bts-2_comp.jpg"
                className="shadow-md-white"
                alt={l('Estudio de grabación con cabina y green screen','TV recording studio with control room and a green screen')}/>
            </Flex>
          </Flex>
          
          <Flex flexWrap="wrap-reverse">
            <Flex className="columna img">
              <StaticImage 
                {...MedImgProps}
                src="../../../content/images/servicios/escenarios/Corredores.jpg"
                className="shadow-md-white"
                alt={l('Carrera de saltos con 7 competidores - Produccion virtual para esports','Runners in a race with seven competitors - Virtual Production for esports')}/>
            </Flex>
            <Flex id="esportsProd" className="columna img">
              <Heading as="h3">{l('E-Sports, Re-plays y Efectos Especiales real-time','E-Sports, Re-Plays and Realtime VFX')}</Heading>
              <Text fontSize="xl" className="parrafoChico">
              {l('Visualiza la acción como nunca antes y muestra los detalles de la estrategia del juego. Análisis de datos y gráficos en tiempo real.', 'Get into the action like never before, and show your audience all the details of the game plan, including match data analisis and realtime graphics.')}
              </Text>
            </Flex>
          </Flex>
            
          <Flex flexWrap="wrap">
            <Flex id="dataProd" className="columna img">
              <Heading as="h3">{l('Gráficas Electorales y Análisis de datos en Tiempo Real','Election data graphs and realtime data analytics')}</Heading>
              <Text fontSize="xl" className="parrafoChico">
                {l('Nos conectamos con servicios de big data e ingresamos sets de datos complejos para hacerlos visibles de forma atractiva, comprensible e interesante. Analíticas e insights que hacen sentido de tus datos a todo tu público.',
                'We connect with big data providers and ingest complex datasets to turn them into exciting, comprehensible and interesting realtime graphics.')}
              </Text>
            </Flex>
            <Flex className="columna img">
              <StaticImage
                {...MedImgProps}
                src="../../../content/images/servicios/escenarios/abcElectionCoverage.jpg"
                className="shadow-md-white"
                alt={l('Escenario virtual de ABC para la cobertura de elecciones electorales con graficas 3D','Virtual Stage for ABC being used to showcase news of election preferences using 3D graphs')} />
            </Flex>
          </Flex>
          
          <Flex flexWrap="wrap-reverse">
            <Flex className="columna img">
              <StaticImage
                {...MedImgProps}
                src="../../../content/images/servicios/escenarios/KNTV_NEWS_DESK.jpg"
                className="shadow-md-white"
                alt={l('Escenario virtual para newsroom','Virtual Set for Newsroom')} />
            </Flex>
            <Flex id="newsProd" className="columna img">
              <Heading as="h3">{l('Sets Virtuales para NewsRooms, Noticieros y Programas de TV', 'Virtual Sets for NewsRooms and TalkShows')}</Heading>
              <Text fontSize="xl" className="parrafoChico">
                {l('La producción con escenarios virtuales permite que el mismo set de grabación sea utilizado para crear distintos programas de tv y noticieros permitiendo que cada uno tenga su propia decoración, layout, efectos especiales y datos a tiempo real.',
                'Virtual Production on Virtual Sets makes it easier for the same space to be used in many diferent TV programs and news casts, allowing each one to have their own decoration, layout, VFX and realtime data, and to switch at the press of a button.')}
              </Text>
            </Flex>
          </Flex>


          <Flex flexWrap="wrap">
            <Flex id="eduProd" className="columna img">
              <Heading as="h3">{l('Ecenarios virtuales Educativos y Didácticos','Virtual Sets for Education Purposes')} </Heading>
              <Text fontSize="xl" className="parrafoChico">
                {l('Los sets virtuales son ideales para la creación de contenido educativo y didáctico que puede ser utilizado en museos, escuelas y capacitación corporativa.','Virtual Sets are an efective tool in the creation of educational content and training materials to be used in schools, museums, or corporate environments.')}
              </Text>
            </Flex>
            <Flex className="columna img">
              <StaticImage
                {...MedImgProps}
                src="../../../content/images/servicios/escenarios/escape-room-virtual-realidad-aumentada1_c.jpg"
                className="shadow-md-white"
                alt={l('Experiencia educativa en cuarto en 3D con una computadora, tres pantallas y un jumpsuit de la casa de papel','Educational experience in a 3D room showcasing a computer, three screens and an orange jumpsuit with the logo of Money Heist')} />
            </Flex>
          </Flex>
          
          <Flex flexWrap="wrap-reverse">
            <Flex className="columna img">
              <StaticImage
                {...MedImgProps}
                src="../../../content/images/servicios/escenarios/camaras-con-motion-tracking.jpeg"
                className="shadow-md-white"
                alt={l('Dolly y camara de broadcast en set de green screen para virtual production','A camera dolly with a broadcast camera on top recording a green screet set for virtual production')} />
            </Flex>
            <Flex id="greenScreenProd" className="columna img">
              <Heading as="h3">{l('Sets de Green Screen, Led Walls y Pantallas', 'Sets with Green Screens, LED Walls and LED Volumes')}</Heading>
              <Text fontSize="xl" className="parrafoChico">
                {l('Nuestra tecnología es compatible con capturas en green screen, pantallas de Led sincronizadas, o enórmes volúmenes de Leds como las grandes producciones de Hollywood. Soluciones que escalan a las necesidades de tu producción.',
                'Our Virtual Production solution is suitable for recording on a green screen, frame-synced LED panels, or huge LED volumes just as seen in Hollywood\'s big productions. Or solutions scales to our client\'s needs.')}
              </Text>
            </Flex>
          </Flex>
          
          <Flex flexWrap="wrap">
            <Flex id="mocapProd" className="columna img">
              <Heading as="h3">{l('Motion Capture (MoCap)','Motion Capture (MoCap)')}</Heading>
              <Text fontSize="xl" className="parrafoChico">
                {l('Las mismas tecnologías utilizadas para hacer motion tracking 3d de las cámaras también son utilizadas para seguir la posición y movimiento de actores y props a tiempo real dentro del set los cuales pueden ser aumentados con modelos 3D y VFX.',
                'The technology used to precisely track the camera\'s position in 3D is leveraged to get the positions of actors and practical props in realtime, allowing them to interact with the virtual world and be augmented with 3D models and realtime VFX.')} 
              </Text>
            </Flex>
            <Flex className="columna img">
              <StaticImage
                {...MedImgProps}
                src="../../../content/images/servicios/escenarios/setCineMoCap.jpg"
                className="shadow-md-white"
                alt={l('Set profesional de grabacion de cine con motion capture moCap', 'Professional film production set with a motion capture setup')} />
            </Flex>
          </Flex>          
        </Flex>

        <Flex justify="flex-start" direction="column" m={['0em auto', '3em auto']} maxWidth="50em">
          <Heading as="h2" className="subHeader" mb="1em" mt="2em">
            {l('Capacitación, Entrenamiento y Soporte', 'Training, Consulting and Support')}
          </Heading>
          <div className="parrafoChico">
            <List
              spacing={3}
              m={['0.5em auto 1em', '0.5em auto 2em']}
              marginLeft="0em"
              paddingLeft="0"
              maxWidth="100%"
              width="100%"
            >
              <ListItem>
                <ListIcon as={ChevronRightIcon} color="azulin.500" />
                  {l('Cursos de capacitación para empresas y estudios de cine.','Training for production companies and film set operators.')}
              </ListItem>
              <ListItem>
                <ListIcon as={ChevronRightIcon} color="azulin.500" />
                  {l('Entrenamiento para el uso de Escenarios Virtuales y Motion Tracking.','Training and support for using Virtual Sets and Motion Tracking.')}
              </ListItem>
              <ListItem>
                <ListIcon as={ChevronRightIcon} color="azulin.500" />
                  {l('Asesoría e instalación para Sets y Foros con escenarios virtuales.','Consulting for installation projects on Sets with Virtual Envirionments.')}
              </ListItem>
              <ListItem>
                <ListIcon as={ChevronRightIcon} color="azulin.500" />
                  {l('Calibración, Montaje y Operación de los equipos durante tu evento.','Equipment installation, calibration and operation for one-off events.')}
              </ListItem>
              <ListItem>
                <ListIcon as={ChevronRightIcon} color="azulin.500" />
                  {l('Garantía y soporte en todas nuestras instalaciones.', 'Warranty and expert support backing up our on-site installations.')}
              </ListItem>
            </List>
          </div>
        </Flex>

        <ContactBanner lang={lang} />


        <Flex className=" img" maxWidth="65em" margin="0 auto" justifyContent="center">
          <StaticImage 
            {...MedImgProps}
            src="../../../content/images/servicios/escenarios/sets-grabacion-virtual-mexico.jpeg"
            className="shadow-md"
            alt={l('Estudio de grabación con green screen con una cámara en el frente','Recording Studio with green screen and a camera')}
          />
        </Flex>


        <Heading as="h1" className="subHeader" mt={['3em', '4em']} mb={['0em', '3em']} id="faq">
          {l('FAQ - Preguntas frecuentes', 'FAQ - Frequently Asked Questions')} <br />
          <small>{l('Sobre los Sets Virtuales y Producciones a tiempo real', 'On Virtual Sets and real-time Virtual Production')}</small>
        </Heading>
        <Flex justify="flex-start" direction={['column', 'column', 'row']} m="3em auto" maxWidth="1240px">
          <Flex maxWidth={['100%','100%','50%']} mr={[0,0,4]}>
          <Accordion id="acc0" 
          // defaultIndex={[0]}
          allowMultiple
          >
              <AccordionItem>
              <FaqItem q={l('¿Que es la producción virtual de video?', 'What is Virtual Production?')} 
              a={l('La producción virtual de video es una técnica que utiliza equipo y software especializado para componer grabaciones en vivo con un mundo virtual generado por computadora a tiempo real. A diferencia de la pantalla verde tradicional, la imagen contiene todos los efectos virtuales desde que se captura en cámara.',
              'Virtual Production is a technique that uses specialized hardware and software to alter a camera image as it is being recorded in order to compose a realistic 3D virtual environment, props, VFX and even characters along the real live image. This process happens in real time, and unlike traditional green screen, the final digital composite is available immediately on set.')} />
              </AccordionItem>
              <AccordionItem>
              <FaqItem q={l('¿Que son los sets de grabación en tiempo real?', 'What are real-time Virtual Sets?')} 
              a={l('Son espacios virtuales modelados en 3D los cuales se pueblan con iluminación, pantallas y efectos completamente virtuales que son libremente controlables por los operadores del set, y que están creados de manera que pueden ser renderizados en tiempo real mediante el uso de un motor de render moderno, tal como Unreal Engine 4.',
              'A Virtual Set is a 3D environment or model that is designed and configured for recording with real actors in real time. It is designed specifically for real-time rendering by using a modern realtime rendering engine, such as Unreal Engine 4. Usually, settings such as illumination, auxiliary virtual screens and environmental effects are controllable by the set operators.')} />
              </AccordionItem>
              <AccordionItem>
              <FaqItem q={l('¿Es posible transmitir en vivo producciónes creadas en sets virtuales?', 'Is it possible to live broadcast or live-stream content recorded in a Virtual Set?')} 
              a={l('La producción virtual es una solución ideal para streaming en vivo y eventos virtuales que suceden en tiempo real, tales como convenciones, festivales y conciertos. Gracias al uso de motores de render en 3D a tiempo real, el contenido virtual se combina con el real al mismo tiempo que se captura, de manera que se puede transmitir de inmediato a televisión e internet. ', 
              'Virtual Production is specially suited to real time events and recordings, such as conventions, festivals and concerts, because the virtual content is rendered real-time and immediately avilable. As such it can be streamed or broadcasted as it is being recorded including impressive digital environments and VFX, without need for further processing.')} />
              </AccordionItem>
              <AccordionItem>
              <FaqItem q={l('¿Que cámaras se necesitan para grabar en escenarios virtuales?', 'What camera is required for a Virtual Production?')} 
              a={l('No es necesario tener cámaras especializadas para tener un resultado impresionante en un escenario virtual. La mayoría de las cámaras de broadcast o cámaras de entusiastas con ópticas intercambiables son compatibles. Sólo se requiere una salida de SDI de calidad profesinal y una óptica de buena calidad. La Blackmagic Pocket Studio y Pocket Cinema, Ursa Mini Pro, así como cámaras RED, Sony, Panasonic, ARRI, etc. son ideales para la realización de producciones virtuales.',
              'It is not necessary to use an expensive top-of-the-line digital film camera in order to achieve good results with Virtual Production. Most cameras geared toward broadcast, and even enthusiast level cine cameras with interchangeable lenses, are compatible. All that is required is an SDI ouptut from the camera and good quality optics. Blackmagic Pocket Studio, Pocket cinema, Ursa Mini Pro, RED cameras, and multiple models by Sony, Panasonic, ARRI, etc, are well suited for Virtual Production.')} />
              </AccordionItem>
              
              
          </Accordion>
          </Flex>
          <Flex maxWidth={['100%', '100%', '50%']} mr={[0, 0, 4]}>
          <Accordion id="ac_faq_2" 
          // defaultIndex={[0]}
          allowMultiple
          >
              <AccordionItem>
              <FaqItem q={l('¿Se puede generar un escenario virtual realista?', 'Is it possible to create a realistic Virtual Set?')} 
                a={l('Los enormes avances sucedidos en los últimos años en los motores de render en tiempo real permiten que sea posible crear escenarios virtuales completamente realistas. Más recientemente, la innovación en técnicas de Ray Tracing mediante tarjetas RTX permiten lograr una iluminación, reflejos y sombras suaves más realistas que nunca.',
                'Yes. Huge innovations in the real-time rendering technology means that fully photorealistic virtual sets are possible. Recent advancements such as Nvidia\'s RTX Ray Tracing even allow for real time global illumination and the most realistic reflections and soft shadows.')} />
              </AccordionItem>
              <AccordionItem>
              <FaqItem q={l('¿Como se crean los escenarios virtuales para cine y broadcast?', 'How are Virtual Sets made?')} 
                a={l('El equipo de modeladores y desarrolladores trabaja de la mano del director y su equipo creativo para traducir su visión a un espacio virtual. Los artistas desarrollan el modelado, texturas e iluminación utilizando técnicas de optimización para lograr el mejor performance en tiempo real. Es necesario que el equipo cuente con experiencia trabajando con renderizado en tiempo real para lograr este objetivo.',
                'The 3D modelling and development teams work with the director and their team to translate their vision into a virtual space. Artists create the 3D models, texturing and lighting work using advanced optimization techniques desingned to push processing performance in real time. It is required for the team to have experience with real-time rendering engines in order to achieve best results.')} />
              </AccordionItem>
              <AccordionItem>
              <FaqItem q={l('¿Como hicieron el escenario de The Mandalorian?', 'How was the virtual set in The Mandalorian made?')}
                a={l('The Mandalorian es notable por hacer uso extenso de la tecnología de sets virtuales en su producción, la cual no hubiera posible al mismo nivel si no hubiera existido la producción virtual. Sus creadores generaron decenas de sets virtuales con iluminación realista y los reprodujeron en enormes volúmenes de pantallas de LED colocados detrás de los actores, los cuales cambiaban con precisión de acuerdo a los movimientos y posición de la cámara.',
                'The Mandalorian is a landmark case study in Virtual Production because of it fully embracing the technology in order to expand the scope of the production and tell a more impactful story. They generated dozens of realistic virtual sets and rendered them live in huge LED walls and ceiling that enveloped the actors. The image being rendered perfectly matched the perspective and movement of the physical camera at all times.')} />
              </AccordionItem>
              {/*
              <AccordionItem>
              <FaqItem q={l('¿Cuanto cuesta hacer una grabación en un escenario virtual?', 'How much does it cost to record in a Virtual Set?')} 
                a={l('... ')} />
              </AccordionItem>
              <AccordionItem>
              <FaqItem q={l('¿Cuanto cuesta construir un set de grabación para escenarios virtuales?', 'How much does it cost to build a recording studio with Virtual Production capabilities?')}
                a={l('... ')} />
              </AccordionItem> */}
          </Accordion>
          </Flex>
        </Flex> 

        <Flex className="flexList flexListLeft">
          <Flex flexWrap="wrap-reverse">
            <Flex className="columna img">
              <StaticImage
                {...MedImgProps}
                src="../../../content/images/servicios/Realidad_Virtual_Mexico3.jpg"
                className="shadow-md-white"
                alt={l('Escena de montañas, nubes y pirámides con una chica con lentes de realidad virtual viviendo la experiencia','Mountains, clouds and pyramids with a girl wearing virtual reality glasses living an experience')} />
            </Flex>
            <Flex id="inmersiveProd" className="columna img">
              <Heading as="h3">{l(<>Produccion de experiencias inmersivas <small>de Realidad Virtual</small></>, <>Production of immersive experiences <small>with Virtual Reality</small></>)}</Heading>
              <Text fontSize="xl" className="parrafoChico">
                {l('El contenido grabado en un set de producción virtual es perfecto para la creación de experiencias inmersivas e interactivas de realidad virtual.',
                'The content that is recorded on a virtual set is perfect for use in the creation of immersive and interactive Virtual Reality experiences.')}
              </Text>
            </Flex>
          </Flex>
          <Flex flexWrap="wrap">
            <Flex id="parkProd" className="columna img">
              <Heading as="h3">{l(<>Parques de Diversiones y Museos <small>Entretenimiento temático</small></>, <>Amusement Parks and Museums <small>Thematic Rides</small></>)}</Heading>
              <Text fontSize="xl" className="parrafoChico">
                {l('Parques de diversión por todo el mundo utilizan diferentes técnicas de Producción Virtual, Realidad Aumentada,  Realidad Virtual y Realidad Mixta para crear atracciónes y expectaculos impresionantes.',
                'Amusement parks around the world leverage Virtual Production, Augmented Reality, Virtual Reality and Mixed Reality in order to offer impressive shows and attractions.')}
              </Text>
            </Flex>
            <Flex className="columna img">
              <StaticImage 
                {...MedImgProps}
                src="../../../content/images/servicios/escenarios/parqueTematico.jpg"
                className="shadow-md-white"
                alt={l('Parque tematico con espectaculo de luces en un lago y una rueda de la fortuna con mickey mouse','Amesement Park showcasing a light show in front of a lake and a ferris wheel with a giant Mickey Mouse.')} />
            </Flex>
          </Flex>

          <Flex flexWrap="wrap-reverse">
            <Flex className="columna img">
              <StaticImage
                {...MedImgProps}
                src="../../../content/images/servicios/escenarios/LentesDeRealidadAumentadaHololens.jpg"
                className="shadow-md-white"
                alt={l('Tecnico colocando el casco de realidad aumentada, microsoft hololens, en un usuario.','Technician placing a Microsoft Hololens augmented reality helmet over the head of an user.')} />
            </Flex>
            <Flex id="publicidadProd" className="columna img">
              <Heading as="h3">{l('Campañas de publicidad interactivas','Interactive advertising campaigns')}</Heading>
              <Text fontSize="xl" className="parrafoChico">
                {l('Utilizando técnicas de Motion Capture, chroma key y 3D se pueden crear sorprendentes campañas de publicidad interactivas con las que se puede cautivar el interes de clientes potenciales de maneras novedosas.',
                'Using Motion Capture techniques, chroma keying and 3D graphics, it is possible to create interactive advertising campaigns where consumer\'s attention can be captured in innovative ways.')}
              </Text>
            </Flex>
          </Flex>

          <Flex flexWrap="wrap">
            <Flex id="artProd" className="columna img">
              <Heading as="h3">{l('Sets Virtuales para Teatro y arte escenico','Virtual Sets for Theater and the Scenic Arts')}</Heading>
              <Text fontSize="xl" className="parrafoChico">
                {l('Los escenarios virtuales pueden convertir una producción de teatro y arte escenico en un increible mundo en el cual los actores pueden interactuar con personajes fantasticos,  efectos especiales y modelos 3D.',
                'Virtual Sets can transform theater and scenic arts productions into incredible worlds where actors interact with fantastic virtual characters, digital VFX and 3D models, all infront of a live audience.')}
              </Text>
            </Flex>
            <Flex className="columna img">
              <StaticImage
                {...MedImgProps}
                src="../../../content/images/servicios/escenarios/arteEscenicoEscenarioVirtual.jpg"
                className="shadow-md-white"
                alt={l('Trapecista volando por el aire con en un aro con un fondo de escenario virtual', 'Acrobat high in the air, holding a hoop, in front of a virtual set.')} />
            </Flex>
          </Flex>
        </Flex>
        <br /><br />
        <ContactBanner lang={lang} />
        <br /><br /><br />
        <Proyectos lang={lang}
          title={l('Ejemplos de Escenarios Virtuales para producción de Cine, TV y VR','Examples of Virtual Sets for Film, Advertising, TV and VR')}
          category="Escenarios virtuales"
          limit={3}
        />

        <br /><br />

        <Flex
          justify="flex-start"
          direction="column"
          p="1em"
          mb="3em"
          borderRadius={[0, 0, '12px', '12px']}
          boxShadow={['none', 'none', '2px 2px 11px 1px #afafaf33']}
          borderLeft={[0, 0, '1px solid #7e969e']}
          borderRight={[0, 0, '1px solid #7e969e']}
        >
          <Heading as="h3"    
            className="subHeader" mb="2em"
            maxWidth="30em" margin="0 auto 2em"
          >
            {l('Somos proveedores de Producciónes, Sets y Escenarios Virtuales en todo México',
            'We provide Virtual Production services, Virtual Sets design, and the installation of Virtual Production technologies')}
          </Heading>
          <Text fontSize="xl" className="parrafoChico">
            {l('Hemos creado producciones e instalaciones para empresas, estudios, televisoras y museos en toda la republica, desde grandes ciudades como el Df / CDMX, Monterrey, Guadalajara, Cancun, Queretaro, San luis y Puebla, hasta pueblos mágicos y munucipios de todo México.',
            'We have experience in the production of Virtual Production materials both for corporate and entertainment clients, as well as helping broadcast studios modernize their equipment and acheive Virtual Production capabilities.')}
          </Text>
        </Flex>

        <Flex className=" img" maxWidth="55em" margin="0 auto">
          <StaticImage
            {...MedImgProps}
            src="../../../content/images/servicios/escenarios/Escenarios-virtuales-camara-tracking-mexico4.jpeg"
            className="shadow-md"
            alt="Estudio de grabación con green screen con una cámara en el frente" />
        </Flex>

      </div>
    </Layout>
  );
};


SetVirtual.propTypes = {
  lang: PropTypes.string
};

export default SetVirtual;
